var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"page-container"},[_c('LoginForm',{on:{"success":_vm.onLogin,"error":_vm.onFailure}}),_vm._v(" "),_c('a',{staticClass:"link--styled login__enquire",attrs:{"href":"mailto:peter.nikashin@igt.com?subject=IGT Casino Lounge - Request Account"}},[_vm._v("Enquire about an account")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77381f55","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Login.vue
// module id = null
// module chunks = 